<template>
  <div id="admin">
    <el-container direction="vertical">
      <el-header :height="`${headerHeight}px`" class="fn-clear">
        <div>
          <img src="@/assets/images/logo.png" />
        </div>
        <div>
          <h1>创客天下平台</h1>
          <p>Ckzone Platform</p>
        </div>
        <div>
          <span>{{ loginDate }}</span>
          <el-button
            type="info"
            icon="el-icon-switch-button"
            circle
            @click="handleLogOut"
          ></el-button>
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px" :style="`min-height:${asideHeight}px;`">
          <el-menu
            :default-active="menuIndex"
            class="admin-aside-menu"
            background-color="#304156"
            text-color="#ffffff"
            active-text-color="#1977ff"
            @select="handleMenu"
          >
            <el-menu-item index="新闻管理">
              <i class="el-icon-news"></i>
              <span slot="title">新闻管理</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { storage } from "@/utils/public.js";
export default {
  name: "admin",
  created() {
    const time = storage.getSession("loginDate");
    this.loginDate = time ? `登录时间： ${time}` : "";
    this.showMenu();
  },
  watch: {
    $route: "showMenu"
  },
  data() {
    return {
      loginDate: "",
      headerHeight: 80,
      menuIndex: "",
      menuList: [
        {
          name: "新闻管理",
          url: "/newList",
          reg: /new/
        }
      ]
    };
  },
  methods: {
    handleLogOut() {
      storage.clearAllSession();
      this.redirectByPath("/");
    },
    showMenu() {
      this.menuList.some(item => {
        var bool = item.reg.test(this.$route.path);
        if (bool) {
          this.menuIndex = item.name;
          return true;
        }
      });
    },
    handleMenu(index) {
      this.menuIndex = index;
      this.menuList.some(item => {
        var bool = item.name === index;
        if (bool) {
          this.redirectByPath(item.url);
          return true;
        }
      });
    }
  },
  computed: {
    asideHeight() {
      return window.innerHeight - this.headerHeight;
    }
  }
};
</script>

<style lang="less">
#admin {
  // header
  .el-header {
    font-size: 14px;
    color: #ffffff;
    background: rgb(48, 65, 86);
    > div {
      float: left;
      line-height: 80px;
      &:nth-child(1) {
        width: 50px;
        padding-top: 15px;
        margin-right: 20px;
      }
      &:nth-child(2) {
        padding-top: 15px;
        line-height: 30px;
        h1 {
          font-size: 26px;
          letter-spacing: 3px;
        }
      }
      &:nth-child(3) {
        float: right;
        span {
          padding-right: 20px;
        }
      }
    }
  }
  // aside
  .el-aside {
    background: rgb(48, 65, 86);
    font-size: 16px;
    color: #b6c6d5;
    .admin-aside-menu {
      border-right: none;
      .el-menu-item,
      .el-submenu__title {
        i {
          color: inherit;
        }
      }
    }
  }

  // 表格的状态颜色
  .listPage {
    .query-bar {
      padding: 20px;
      margin-top: 10px;
      background: #fff;
      > .el-row {
        & + .el-row {
          padding-top: 20px;
        }
        > .el-col {
          padding-right: 10px;
        }
      }
    }
    .toolbar {
      padding: 0 20px;
      background: #fff;
    }
    .query-table {
      padding: 20px;
      background: #fff;
      .el-table {
        font-size: 12px;
        color: #304156;
        thead tr th {
          color: #333 !important;
          background: #f8f8f6;
        }
        .clickableLink {
          color: #3280fc;
        }
      }
    }
  }
}
</style>
